<template>
	<div class="menu-div">
		<div class="menu-top">
			<span v-if="!isCollapse">{{$t('message.leftMenu.title')}}</span>
			<a v-if="isCollapse" class="in" @click="toggleCollapse"><el-icon size="22" color="#909399"><Expand /></el-icon></a>
			<a v-if="!isCollapse" class="out" @click="toggleCollapse"><el-icon size="22" color="#909399"><Fold /></el-icon></a>
		</div>	
		<el-scrollbar style="height: calc(100vh - 140px);"> 
			<el-menu 
				:default-active="ac_index" 
				@select="select"  
				:collapse="isCollapse"  
				class="el-menu-vertical-demo"
				@open="handleOpen"
				@close="handleClose"
				>
                <span v-for="item in menu.moduleList" :key="item.id">
                    <router-link :to="{path:item.url,query:{init:1}}">
                        <el-menu-item v-if="item.listItem == null || item.listItem.length == 0" :index="item.id" class="menu-item-with-badge">
                            <el-icon>
                                <component :is="getIconComponent(item.icon)"></component> 
                            </el-icon>
                            <template #title>
                                <span>{{$t(item.moduleI118n)}}</span>
                                <span v-if="item.id=='9801' && alarmCount>0" class="menu-badge">{{ alarmCount>99?'99+':alarmCount }}</span>
                                <span v-if="item.id=='9802' && msgCount>0" class="menu-badge">{{ msgCount>99?'99+':msgCount }}</span>
                            </template>
                        </el-menu-item>
                    </router-link>
					<el-sub-menu v-if="item.listItem != null && item.listItem.length > 0" :index="item.id">
						<template #title>
							<el-icon>
								<component :is="getIconComponent(item.icon)"></component> 
							</el-icon>
							<span>{{$t(item.moduleI118n)}}</span>
						</template>  
                        <div v-for="two in item.listItem" :key="two.id">
                            <router-link :to="{path:two.url,query:{init:1}}">
                                <el-menu-item :index="two.id" class="menu-item-with-badge">
									<el-icon size="10">
										<component :is="ArrowRight"></component>
									</el-icon>
                                <template #title>
                                    <span>{{$t(two.moduleI118n)}}</span>
                                    <span v-if="two.id=='9801' && alarmCount>0" class="menu-badge">{{ alarmCount>99?'99+':alarmCount }}</span>
                                    <span v-if="two.id=='9802' && msgCount>0" class="menu-badge">{{ msgCount>99?'99+':msgCount }}</span>
                                </template>
								</el-menu-item>
							</router-link>
						</div>
					</el-sub-menu>
				</span>
			</el-menu>
		</el-scrollbar>
	</div>
</template>
<script setup>
    import {ref,reactive,onMounted,watch,getCurrentInstance,computed} from 'vue'
    import { useStore } from 'vuex'
	import {useRoute} from 'vue-router'
	// 按需导入图标，减少包体积
	import {
		Histogram,UserFilled,CreditCard,Bowl,Check,DArrowRight,DArrowLeft,Expand,Fold,ArrowRight,
		House,User,Upload,Location,Document,DataAnalysis,Avatar,Notebook,Setting,
		DocumentCopy,Connection,Bell,Picture,Refresh,Box,Link,Monitor,Warning,ChatDotRound,
		Promotion,View,DataBoard,OfficeBuilding,PieChart
	} from '@element-plus/icons-vue'
	
	const icons = {
		Histogram,UserFilled,CreditCard,Bowl,Check,DArrowRight,DArrowLeft,Expand,Fold,ArrowRight,
		House,User,Upload,Location,Document,DataAnalysis,Avatar,Notebook,Setting,
		DocumentCopy,Connection,Bell,Picture,Refresh,Box,Link,Monitor,Warning,ChatDotRound,
		Promotion,View,DataBoard,OfficeBuilding,PieChart
	}
	
	// 图标映射函数
	const getIconComponent = (iconName) => {
		return icons[iconName] || CreditCard // 默认使用CreditCard
	}
	const emit = defineEmits(['changeMenuCollapse'])
	
	const menu = reactive({
		moduleList:[]
	})
	
	const prop = defineProps({
		moduleId:{
			type:String,
			default:''
		}
	})


	watch(prop, (newVal, oldVal) => {
		initModule(prop.moduleId)
	})

	const {proxy} = getCurrentInstance()
	const route = useRoute()
	const ac_index = ref("0")
	const isCollapse = ref(false)
	
    const store = useStore()

    onMounted(async ()=>{
		initModule(prop.moduleId)
        await store.dispatch('notice/loadCounts')
	})

    const msgCount = computed(()=> store.getters['notice/msgCount'])
    const alarmCount = computed(()=> store.getters['notice/alarmCount'])

	const initModule = async(moduleId) => {
		try{
			// 先从 vuex 中获取左侧菜单数据
			let cachedData = store.getters['leftMenu/getMenuDataByFid'](moduleId)
			
			let data = null
			if(cachedData != null){
				// 如果 vuex 中有数据，直接使用
				data = cachedData
			} else {
				// 如果 vuex 中没有数据，从后台获取
				const params = {fid:moduleId,type:'M'}
				const res = await new proxy.$request(proxy.$urls.m().sysPower_listUserModule,params).modepost()
				if(res.data.data != null){
					data = res.data.data
					// 将数据存储到 vuex 中
					store.dispatch('leftMenu/setMenuData', { fid: moduleId, data: data })
				}
			}
			
			// 设置菜单数据
			if(data != null){
				menu.moduleList = data
			}
			
			// 设置当前路由对应的菜单项为激活状态
			setActiveMenuByRoute()
		}catch(e){
			new proxy.$tips(e,'error')
		}
	}
	
	// 根据当前路由设置激活的菜单项
	const setActiveMenuByRoute = () => {
		const currentPath = route.path
		let activeMenuId = null
		
		// 遍历菜单列表，查找匹配的菜单项
		for (const item of menu.moduleList) {
			// 检查主菜单项
			if (item.url === currentPath) {
				activeMenuId = item.id
				break
			}
			
			// 检查子菜单项
			if (item.listItem && item.listItem.length > 0) {
				for (const subItem of item.listItem) {
					if (subItem.url === currentPath) {
						activeMenuId = subItem.id
						break
					}
				}
				if (activeMenuId) break
			}
		}
		
		if (activeMenuId) {
			ac_index.value = activeMenuId
		}
	}

	const handleOpen = (key, keyPath) => {
		// 菜单展开事件
	}
	const handleClose = (key, keyPath) => {
		// 菜单收起事件
	}
	const select = (key, keyPath) => {
		ac_index.value = key
		// 菜单选择事件
	}
	const toggleCollapse = () => {
		isCollapse.value = !isCollapse.value
	}
	watch(isCollapse, (newVal, oldVal) => {
		emit('changeMenuCollapse',{
			action:newVal
		})
	})
	
	// 监听路由变化，自动设置激活菜单
	watch(() => route.path, () => {
		if (menu.moduleList.length > 0) {
			setActiveMenuByRoute()
		}
	})
</script>
<style scoped>
	.el-menu-vertical-demo:not(.el-menu--collapse) {
	  width: 200px;
	  min-height: 400px;
	}
  .el-menu {
	  border-right: solid 0px var(--el-menu-border-color);
  }
  .menu-div{
	  display: block;
	  border-right: 1px solid #dcdfe6;
	  list-style: none;
	  position: relative;
	  margin: 0;
	  padding-left: 0;
	  background-color: var(--el-menu-bg-color);
	  box-sizing: border-box;
  }
  .el-menu--collapse .el-sub-menu > .el-sub-menu__title > span {
	height: 0;
	width: 0;
	overflow: hidden;
	visibility: hidden;
	display: inline-block;
  }
  .el-menu--collapse .el-sub-menu > .el-sub-menu__title .el-sub-menu__icon-arrow {
	display: none;
  }
  a {
	text-decoration: none;
  }
  .el-menu-vertical-demo {
	height: 100%;
  }
  .menu-top {
	position: relative;
	line-height: 45px;
	font-size: 14px;
	cursor: pointer;;
	width: 100%;
	height: 48px;
	border-bottom: 1px solid #f1eeee;
	-webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
	box-shadow: 0 2px 4px rgba(0, 21, 41, .08);
  }
  .menu-top a {
	position: absolute;
	right: 10px;
	top: 6px;
  }
  .menu-top a.in {
	position: absolute;
	right: 20px;
	top: 6px;
  }
  .menu-top span {
	display: block;
	text-align: center;
	color: #4f5052;
	font-weight: bold;
  }
  .menu-item-with-badge{
    position: relative;
  }
  .menu-badge{
    display: inline-block;
    margin-left: 6px;
    min-width: 16px;
    height: 16px;
    padding: 0px;
    background: #ff4d4f;
    color: #fff;
    border-radius: 8px;
    line-height: 16px;
    font-size: 12px;
    text-align: center;
  }
  .item {
	width: 100%;
  }
  
  /* 菜单项选中样式优化 */
  :deep(.el-menu-item:hover) {
	background-color: var(--el-color-primary-light-9);
	color: var(--el-color-primary);
  }
  
  :deep(.el-menu-item.is-active) {
	background-color: var(--el-color-primary-light-9);
	color: var(--el-color-primary);
	font-weight: 600;
  }
  
  :deep(.el-menu-item.is-active .el-icon) {
	color: var(--el-color-primary);
  }
  
  /* 子菜单标题样式 */
  :deep(.el-sub-menu__title:hover) {
	background-color: var(--el-color-primary-light-9);
	color: var(--el-color-primary);
  }
  
  /* 子菜单项样式 */
  :deep(.el-sub-menu .el-menu-item:hover) {
	background-color: var(--el-color-primary-light-9);
	color: var(--el-color-primary);
  }
  
  :deep(.el-sub-menu .el-menu-item.is-active) {
	background-color: var(--el-color-primary-light-9);
	color: var(--el-color-primary);
	font-weight: 600;
  }
  
  :deep(.el-sub-menu .el-menu-item.is-active .el-icon) {
	color: var(--el-color-primary);
  }
  </style>